import { SyncRequestClient } from 'ts-sync-request/dist'
import { oauthClient, OAuthClient } from './OAuthClient';


type REST_METHODS = "GET"|"POST"|"PUT"|"DELETE";

export class ApiOAuthClient {

    static getHeaders(accessToken:string) {
        return {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: 'Bearer '+accessToken
        };
    }

    static getOptions(method:REST_METHODS, accessToken:string, data:any|null) : RequestInit {
        if(data == null) {
            return {
                method: method,
                headers: ApiOAuthClient.getHeaders(accessToken),
                credentials: 'include',
                mode: 'cors'
            };
        }
        else {
            return {
                method: method,
                body: JSON.stringify(data),
                headers: ApiOAuthClient.getHeaders(accessToken),
                credentials: 'include',
                mode: 'cors'
            };
        }
    }

    static get(url: string): Promise<Response|null> {
        let accessToken = oauthClient.getAccessToken();
        if(accessToken == null) return Promise.resolve(null);

        let options = ApiOAuthClient.getOptions("GET", accessToken, null);
        return fetch(url, options);
    }

    static post(url: string, data: any): Promise<Response|null> {
        let accessToken = oauthClient.getAccessToken();
        if(accessToken == null) return Promise.resolve(null);

        let options = ApiOAuthClient.getOptions("POST", accessToken, data);
        return fetch(url, options);
    }
    static put(url: string, data: any): Promise<Response|null>  {
        let accessToken = oauthClient.getAccessToken();
        if(accessToken == null) return Promise.resolve(null);

        let options = ApiOAuthClient.getOptions("PUT", accessToken, data);
        return fetch(url, options);
    }

    static delete(url: string, data: any): Promise<Response|null> {
        let accessToken = oauthClient.getAccessToken();
        if(accessToken == null) return Promise.resolve(null);

        let options = ApiOAuthClient.getOptions("DELETE", accessToken, data);
        return fetch(url, options);
    }

    static postFile(url:string, data: FormData): Promise<Response|null>{
        let accessToken = oauthClient.getAccessToken();
        if(accessToken == null) return Promise.resolve(null);

        let options: RequestInit ={
           method: 'POST',
           body: data,
           headers: {
               Accept : "application/json",
               Authorization: 'Bearer '+accessToken
           },
           credentials: 'include',
       };
       return fetch(url, options);
   }
}

